var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0664 17.8711C17.6057 17.8711 18.043 17.4339 18.043 16.8945C18.043 16.3552 17.6057 15.918 17.0664 15.918C16.5271 15.918 16.0898 16.3552 16.0898 16.8945C16.0898 17.4339 16.5271 17.8711 17.0664 17.8711Z",
    fill: "#183171",
    stroke: "#FDFEFF",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4609 17.6758C22.0003 17.6758 22.4375 17.2386 22.4375 16.6992V13.0859C22.4375 10.932 20.6852 9.17969 18.5312 9.17969H17.3576V5.73564C17.3576 2.573 14.7291 0 11.4982 0C8.26733 0 5.63882 2.573 5.63882 5.73564V9.17969H4.46875C2.31484 9.17969 0.5625 10.932 0.5625 13.0859V21.0938C0.5625 23.2477 2.31484 25 4.46875 25H18.5312C20.6852 25 22.4375 23.2477 22.4375 21.0938C22.4375 20.5544 22.0003 20.1172 21.4609 20.1172C20.9216 20.1172 20.4844 20.5544 20.4844 21.0938C20.4844 22.1707 19.6082 23.0469 18.5312 23.0469H4.46875C3.3918 23.0469 2.51562 22.1707 2.51562 21.0938V13.0859C2.51562 12.009 3.3918 11.1328 4.46875 11.1328H18.5312C19.6082 11.1328 20.4844 12.009 20.4844 13.0859V16.6992C20.4844 17.2386 20.9216 17.6758 21.4609 17.6758ZM15.4044 9.17969H7.59194V5.73564C7.59194 3.64995 9.34429 1.95312 11.4982 1.95312C13.6521 1.95312 15.4044 3.64995 15.4044 5.73564V9.17969Z",
    fill: "#183171",
    stroke: "#FDFEFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69336 17.8711C10.2327 17.8711 10.6699 17.4339 10.6699 16.8945C10.6699 16.3552 10.2327 15.918 9.69336 15.918C9.15402 15.918 8.7168 16.3552 8.7168 16.8945C8.7168 17.4339 9.15402 17.8711 9.69336 17.8711Z",
    fill: "#183171",
    stroke: "#FDFEFF",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.03125 17.8711C6.57059 17.8711 7.00781 17.4339 7.00781 16.8945C7.00781 16.3552 6.57059 15.918 6.03125 15.918C5.49191 15.918 5.05469 16.3552 5.05469 16.8945C5.05469 17.4339 5.49191 17.8711 6.03125 17.8711Z",
    fill: "#183171",
    stroke: "#FDFEFF",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3555 17.8711C13.8948 17.8711 14.332 17.4339 14.332 16.8945C14.332 16.3552 13.8948 15.918 13.3555 15.918C12.8161 15.918 12.3789 16.3552 12.3789 16.8945C12.3789 17.4339 12.8161 17.8711 13.3555 17.8711Z",
    fill: "#183171",
    stroke: "#FDFEFF",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.f691cc1714f9bfa496ed4118ad7243fb.svg";
export { ForwardRef as ReactComponent };